The upper limit of hirers to return from the end of the list.

Excess hirers will be trimmed from the start of the list.

`first` and `last` cannot be specified in the same query.
